import styled from '@emotion/styled';
import { fontSizes } from 'app/typography';
import { tableHover } from 'app/colors';
import css from '@emotion/css';

export const InfoWrapper = styled.div<{
  noMarginBottom?: boolean;
}>`
  background: ${tableHover};
  border-radius: 4px;
  padding: 10px 10px 6px;
  ${({ noMarginBottom }) =>
    noMarginBottom
      ? css`
          margin-bottom: 0;
        `
      : css`
          margin-bottom: 20px;
        `}

  margin-top: 17px;
`;

export const TextWrapper = styled.div<{
  marginBottom?: boolean;
}>`
  &:not(:last-child) {
    margin-bottom: 15px;
  }
  span {
    line-height: 110%;
  }

  .field-value {
    white-space: break-spaces;
    word-break: break-all;
    font-size: ${fontSizes.micro};
  }
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: 13px;
    `}
`;
export const SwitchBlockWrapper = styled.div`
  margin-bottom: 4px;
`;
export const Wrapper = styled.div`
  width: 100%;
  margin-top: 16px;
`;
